module.exports = __webpack_public_path__ + "img/shoulder_width.a2b0d94b.png";